/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import './style/bolmateExternalLink.scss';

import {Icon} from '@iconify/react';

import classNames from 'classnames';

import React, {MouseEventHandler, PropsWithChildren} from 'react';

interface Props {
    href: string;
    label?: string;
    showIcon?: boolean;
    className?: string;
    /** Native tooltip on the anchor (e.g. an icon-only link). */
    title?: string;
    onClick?: MouseEventHandler;
}

export default function BolmateExternalLink(props: PropsWithChildren<Props>) {
    const {href, children, label, showIcon = true, className, title, onClick} = props;

    return (
        <a
            href={href}
            target='_blank'
            rel='noopener noreferrer'
            className={classNames('bolmate-external-link', className)}
            title={title}
            onClick={onClick}
        >
            {children ?? label}
            {showIcon && <Icon icon='mdi:open-in-new' className='bolmate-external-link-icon' />}
        </a>
    );
}
